<div [matTooltip]="'Emoji'" [matTooltipPosition]="'before'">
  <button
    mat-icon-button
    [class.active]="active"
    [y42Permission]="state.isCanvasEditable"
    [permissionTooltip]="'You do not have permission to edit the asset'"
    [intercomTarget]="'toolbar-insert-emoji'"
    (click)="emojiMenuTrigger.openMenu()"
  >
    <fa-icon [icon]="['fal', 'smile']"></fa-icon>
    <div class="menu-trigger" #emojiMenuTrigger="matMenuTrigger" [matMenuTriggerFor]="emojisMenu"></div>
  </button>
</div>

<mat-menu
  class="toolbar-panel-emojis-menu"
  #emojisMenu="matMenu"
  [overlapTrigger]="false"
  [backdropClass]="toolbarBackdropClass"
>
  <div class="emojis-menu">
    <button mat-icon-button *ngFor="let emoji of emojis; trackBy: trackByValue" (click)="selectTool.emit(emoji)">
      <span [y42Emoji]="emoji.code"></span>
    </button>
  </div>
</mat-menu>
